import React from 'react';
import _ from 'lodash';
import is from 'is_js';
import dateFormat from 'dateformat';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';

const FormDateField = ({
  id,
  label,
  autoFocus,
  disabled,
  fullWidth,
  variant,
  InputProps,
  getValue,
  onBlur,
  onChange,
}) => {
  const {
    control,
    setValue,
    formState: { errors },
    isRequired,
  } = useFormContext();

  const required = isRequired(id);

  return (
    <>
      <Controller
        name={id}
        control={control}
        render={({ field }) => {
          const fieldParams = {
            ...field,
            value: getValue(field.value),
          };
          if (onBlur) {
            fieldParams.onBlur = (e) => {
              field.onBlur();
              setValue(id, onBlur(e), { shouldValidate: true });
            };
          }
          if (onChange) {
            fieldParams.onChange = (e) =>
              field.onChange(onChange(e, field.value));
          }
          return (
            <TextField
              {...fieldParams}
              autoFocus={autoFocus}
              label={label}
              required={required}
              error={is.truthy(errors[id])}
              helperText={_.get(errors[id], 'message')}
              disabled={disabled}
              fullWidth={fullWidth}
              variant={variant}
              InputProps={InputProps}
              InputLabelProps={{ shrink: true }}
              type="date"
            />
          );
        }}
      />
    </>
  );
};

FormDateField.defaultProps = {
  label: '',
  autoFocus: false,
  disabled: false,
  fullWidth: false,
  variant: 'standard',
  InputProps: undefined,
  onBlur: undefined,
  onChange: undefined,
  getValue: (value) => {
    if (value) {
      if (Number.isInteger(value)) {
        return dateFormat(value, 'yyyy-mm-dd');
      }
      return value;
    }
    return '';
  },
};

FormDateField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
  InputProps: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  getValue: PropTypes.func,
};

export default FormDateField;
